module.exports = __webpack_public_path__ + "img/xmr.26a14f1c.svg";